import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app-header" }
const _hoisted_2 = { class: "app-header__logo" }
const _hoisted_3 = { class: "app-header__main" }
const _hoisted_4 = { class: "app-header__rest" }

import { computed, watch } from "vue"
import { useRoute } from "vue-router"
import { headerStore } from "@/store/header"
import { rootStore } from "@/store/index"
import HeaderLogo from "./HeaderLogo.vue"
import HeaderAccessGroupSelect from "./HeaderAccessGroupSelect.vue"
import HeaderNavLinks from "./HeaderNavLinks.vue"
import HeaderNotificationsButton from "./HeaderNotificationsButton.vue"
import HeaderMessagesButton from "./HeaderMessagesButton.vue"
import HeaderUserDropdown from "./HeaderUserDropdown.vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'AppHeader',
  setup(__props) {

const route = useRoute()
const store = headerStore()
const root = rootStore()

const showAccessGroup = computed(
	() => route.path === '/main' && store.accessGroups.length > 0
)

watch(
	() => root.globalJWT,
	jwt => {
		if (jwt) store.loadAccessGroups()
	},
	{ immediate: true }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(HeaderLogo)
    ]),
    _createElementVNode("div", _hoisted_3, [
      (showAccessGroup.value)
        ? (_openBlock(), _createBlock(HeaderAccessGroupSelect, {
            key: 0,
            class: "app-header__select"
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(HeaderNavLinks, { class: "app-header__nav" }),
        _createVNode(HeaderNotificationsButton),
        _createVNode(HeaderMessagesButton),
        _createVNode(HeaderUserDropdown)
      ])
    ])
  ]))
}
}

})